import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex'


//开发所需方法与组件 start

import echarts from 'echarts'// 引入echarts 

import './assets/elementUi/components.js';//element组件引用
import './api/axios.js';//axios引用 示例：this.$axiso.请求方式
import baseAPI from'./api/base.js';//公共api
import './api/customOrder.js';//自定义指令

import 'element-ui/lib/theme-chalk/index.css';//element样式

Vue.prototype.$echarts = echarts//挂载echarts到实例 示例:let myChart = this.$echarts.init(初始化dom))) myChart.setOption({图标数据})
Vue.prototype.$baseAPI = baseAPI;//挂载api对象到实例 示例：this.$baseAPI.方法名

//开发所需方法与组件 end

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
